<template>
  <div class="ratio">
    <!-- <div class="wgTpye-breadcrumb" ref="brandBox">
      <span @click="changeShow" class="cursor">{{$route.query.type==3?'首页':'日常职守'}}</span>
      <span>/</span>
      <span class="c0">满桩值设置</span>
    </div> -->
    <div class="interface" ref="interfaceBox">
      <p>接口状态</p>
      <ul v-if="brands && brands.length">
        <li v-for="item in brands" :key="item.brandId">{{item.brandName}}<img v-if="item.urlStatus === 1" class="x" src="../../assets/xx.png"><img v-if="item.urlStatus === 0" class="xx" src="../../assets/x.png"></li>
      </ul>
    </div>
    <div class="ratio-form" ref="searchBox">
      <p>满桩值设置</p>
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="任务名称：">
          <el-input v-model="formInline.alias" placeholder="任务名称"></el-input>
        </el-form-item>
        <el-form-item label="站点名称：">
          <el-input v-model="formInline.siteName" placeholder="站点名称"></el-input>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select v-model="formInline.openSwitch" placeholder="状态">
            <el-option label="全部" :value="undefined"></el-option>
            <el-option label="开启" :value="1"></el-option>
            <el-option label="关闭" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button  @click="onReset">重置</el-button>
          <el-button type="primary" @click="onAdd">新建任务</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="ratio-table">
       <w-table
        :height="tableViewHeight"
        v-loading.body="tableLoading"
        :data-list="tableData"
        :columns="ratioTablesColumns"
        :pageNo="formData.pageNum"
        :pageSize="formData.pageSize"
        :total="total"
        :bPagination="false"
        @pageNoChange="pageNoChange"
        @pageSizeChange="pageSizeChange"
        >
        <template slot-scope="props" slot="cell">
          <span v-if="props.column.label === '序号'">{{ props.index + 1 + (formData.pageNum - 1) * formData.pageSize}}</span>
          <span v-else-if="props.column.label === '执行时间'">
            {{changeWeeks(props.row)}}
          </span>
          <span v-else-if="props.column.label === '站点数'">
            {{props.row.siteCount || 0}}
          </span>
          <span v-else-if="props.column.label === '任务开关'">
            <el-switch v-model="props.row.openSwitch" @change="changeSwitch(props.row)" :active-value="1" :inactive-value="0"></el-switch>
          </span>
          <span v-else-if="props.column.label === '操作'">
            <el-button size="mini" @click="onEditPre(props.row)" type="text">查看</el-button>
            <span class="line-e">|</span>
            <el-button size="mini" @click="onDelPre(props.row)" type="text">删除</el-button>
          </span>
          <span v-else>{{ props.row[props.column.property]}}</span>
        </template>
      </w-table>
    </div>
  </div>
</template>

<script>
import WTable from '@/components/Table/index.vue'
import { ratioTablesColumns } from './staticData.js'
import { mapGetters } from 'vuex'
import Api from '@/api'

export default {
  name: 'ratio',
  data() {
    return {
      formInline: {
        alias: undefined,
        siteName: '',
        openSwitch: undefined
      },
      ratioTablesColumns,
      tableData: [],
      tableLoading: false,
      formData: {
        pageNum: 1,
        pageSize: 10
      },
      total: 1,
      tableViewHeight: ''
    }
  },
  computed: {
    ...mapGetters(['brands', 'selfAreaId'])
  },
  created() {
    this.initData()
  },
  methods: {
    // 计划视图区域
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.brandBox && this.$refs.brandBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        if (this.$refs.interfaceBox && this.$refs.interfaceBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        // console.log('H', H)
        // 56: 导航栏高度修正
        // 32: 底部padding修正
        this.tableViewHeight = window.innerHeight - H - 8
      })
    },
    changeSwitch(row) {
      const params = {
        selfAreaId: this.selfAreaId,
        openSwitch: row.openSwitch,
        id: row.id
      }
      Api.changeMagnifyOpen(params)
        .then(res => {
          console.log(res)
          if (res.code === 200) {
            let message = ''
            if (row.openSwitch) {
              message = '任务已开启，正在执行中！'
            } else {
              message = '任务已暂停！'
            }
            this.$message({
              message,
              type: 'success'
            })
          } else {
            this.$message.error(`接口：/api/site/magnify/open/{id} ${res.message}`)
          }
        })
        .catch(err => {
          console.log('the changeMagnifyOpen has problem: ', err)
        })
    },
    changeWeeks(row) {
      const t = ` ${row.startHour}-${row.endHour}`
      const ws = row.week.split(',')
      const wsText = []
      for (let i = 0, len = ws.length; i < len; i++) {
        this.getWeekText(i, ws[i]) && wsText.push(this.getWeekText(i, ws[i]))
      }
      return `${wsText.length ? wsText.join(',') : ''}${t}`
    },
    getWeekText(week, weekValue) {
      if (weekValue === '1') {
        return {
          0: '星期天',
          1: '星期一',
          2: '星期二',
          3: '星期三',
          4: '星期四',
          5: '星期五',
          6: '星期六'
        }[week]
      }
      return false
    },
    onAdd() {
      this.$emit('showRatioEdit', null)
    },
    onEditPre(row) {
      this.$emit('showRatioEdit', row)
    },
    onDelPre(row) {
      this.$confirm(`你是否确定删除“${row.alias}”任务？`, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.onDelTask(row)
      }).catch(() => {})
    },
    onDelTask(row) {
      const params = {
        selfAreaId: this.selfAreaId,
        id: row.id
      }
      Api.delMagnify(params)
        .then(res => {
          console.log(res)
          if (res.code === 200) {
            const message = '任务删除成功！'
            this.$message({
              message,
              type: 'success'
            })
            this.initData()
          } else {
            this.$message.error(`接口：/api/site/magnify/open/{id} ${res.message}`)
          }
        })
        .catch(err => {
          console.log('the changeMagnifyOpen has problem: ', err)
        })
    },
    onReset() {
      this.formInline.alias = undefined
      this.formInline.siteName = ''
      this.formInline.openSwitch = undefined
      this.initData()
    },
    changeShow() {
      this.$emit('changeShow')
    },
    onSubmit() {
      this.initData()
    },
    initData() {
      const params = {
        selfAreaId: this.selfAreaId,
        areaId: this.selfAreaId,
        ...this.formInline
      }
      Api.getMagnify(params)
        .then(res => {
          console.log(res)
          if (res.code === 200) {
            this.tableData = res.data
          } else {
            this.$message.error(`接口：/api/site/magnify ${res.message}`)
          }
          this.calcView()
        })
        .catch(err => {
          console.log('the getMagnify has problem: ', err)
        })
    },
    pageNoChange(page) {
      this.formData.pageNum = page
      this.initData()
    },
    pageSizeChange(size) {
      this.formData.pageSize = size
      this.initData()
    }
  },
  components: {
    WTable
  }
}
</script>

<style lang="less">
.ratio .el-form--inline .el-form-item {
  margin-bottom: 0;
}
</style>

<style lang="less" scoped>
.ratio {
  .wgTpye-breadcrumb {
    width: 100%;
    padding: 20px 16px 4px 20px;
    span {
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
    }
    span + span {
      margin-left: 10px;
    }
  }
  .interface {
    margin: 16px;
    padding: 16px;
    background-color: #FFF;
    p {
      font-size: 16px;
      font-weight: bold;
      color: #111;
      line-height: 1;
      margin-bottom: 16px;
    }
    ul {
      display: flex;
      li {
        flex: 1;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        line-height: 1;
      }
      img {
        margin-left: 14px;
      }
      li + li {
        padding-left: 16px;
        border-left-width: 1px;
        border-left-style: solid;
        border-left-color: #DDD;
      }
    }
    img.x {
      width: 16px;
      height: 16px;
    }
    img.xx {
      width: 14px;
      height: 14px;
    }
  }
  .ratio-form {
    margin: 16px;
    padding: 16px;
    background-color: #FFF;
    p {
      font-size: 20px;
      font-weight: bold;
      color: #111;
      line-height: 1;
      margin-bottom: 24px;
    }
  }
  .ratio-table {
    margin: 16px;
    background-color: #FFF;
    .line-e {
      display: inline-block;
      margin: 0 10px;
      color: #EBEBEB;
    }
  }
}
</style>
